import '~/assets/scss/analytic.scss'

import findForm from '~/js/modules/find-form';
import '~/js/modules/promo-banner';
import Tabs from '~/js/modules/tabs';

window.addEventListener(`DOMContentLoaded`, () => {
  const findForms = document.querySelectorAll(`.js-find-form`)
  if (findForms.length) {
    findForms.forEach((form, i) => new findForm(form))
  }

  const mainTabsControls = document.querySelectorAll(".js-tabs-controls-main")
  const mainTabsContainer = document.querySelectorAll(".js-tabs-container-main")
  if (mainTabsControls.length && mainTabsContainer.length) {
    mainTabsControls.forEach((control, i) => new Tabs(control, mainTabsContainer[i], '-main'))
  }
});
